import { useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";

import AddDriverWrapper from "./AddDriver.style";
import yesIcon from "../../assets/images/icons/icon_driver-select-yes.svg";
import noIcon from "../../assets/images/icons/icon_driver-select-no.svg";
import { Toast } from "primereact/toast";
import * as renewalService from "../../services/renewal-service";
import * as globalUtils from "../../helpers/utils";

import propTypes from "prop-types";
import { Button } from "primereact/button";
const AddDriver = (props) => {
  const { i18n, driverInfo, editMode, updateDriverListHandler, driversList } =
    props;

  const [disableForm, setDisableForm] = useState(!!editMode);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const [driver, setDriver] = useState(editMode ? driverInfo : null);

  const formik = useFormik({
    initialValues: {
      idNumber: editMode && driver ? driver.IDNO : "",
      yearOfBirth: editMode && driver ? driver.gregDob.split("-")[2] : "",
      monthOfBirth: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.idNumber) {
        errors.idNumber = i18n.t("ERROR.REQUIRED");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.idNumber)) {
        errors.idNumber = (
          <span className="lato">
            {i18n.t("ERROR.MUST_10_DIGITS") + " 1 , 2"}
          </span>
        );
      }
      if (!data.yearOfBirth) {
        errors.yearOfBirth = i18n.t("ERROR.REQUIRED");
      }
      if (!data.monthOfBirth) {
        errors.monthOfBirth = i18n.t("ERROR.REQUIRED");
      }
      return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: ({ idNumber, yearOfBirth, monthOfBirth }) => {
      const isExists = driversList.findIndex((ele) => ele.IDNO === idNumber);
      if (isExists == -1) {
        setLoading(true);
        renewalService
          .getDriverDetailsRequest({
            productCode: "ALL",
            idNumber: idNumber,
            dob: `${monthOfBirth}-${yearOfBirth}`, // the month is hard coded because it'n used in the api just the format is required MM-yyyy
            mobileNumber: "+966500000000",
            languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
          })
          .then((response) => {
            setLoading(false);
            const { data } = response;
            if (data.resultCode === "S") {
              setDriver(data.driverDetails.vehicleDriverDetailsArray[0]);
              setDisableForm(true);
              saveDriver(data.driverDetails.vehicleDriverDetailsArray[0]);
            } else {
              toast.current.show({
                severity: "error",
                summary: i18n.t("ERROR.error"),
                detail: data.resultMessage,
                life: 6000,
              });
            }
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: i18n.t("ERROR.error"),
              detail: error.error,
              life: 6000,
            });
          });
      } else {
        toast.current.show({
          severity: "warn",
          summary: i18n.t("ERROR.error"),
          detail: i18n.t("ERROR.duplicatedDriver"),
          life: 6000,
        });
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const onChangeGender = (gender) => {
    const myDriver = { ...driver };
    myDriver.genderCode = gender;
    setDriver(myDriver);
  };

  const isMale = (genderCode) => {
    return !genderCode || genderCode == "M" || genderCode == "1";
  };

  const cancelAddDriver = (e) => {
    e.preventDefault();
    setDriver(null);
    setDisableForm(false);
    formik.resetForm();
    props.cancelUpdateDriverHandler();
  };

  const saveDriver = (driver) => {
    // e.preventDefault();
    const myDriversList = [...driversList];
    if (editMode) {
      const index = myDriversList.findIndex((ele) => ele.IDNO === driver.IDNO);
      if (index != -1) {
        myDriversList[index] = driver;
      }
    } else {
      myDriversList.push(driver);
    }
    updateDriverListHandler(myDriversList);
    setDriver(null);
    setDisableForm(false);
    formik.resetForm();
  };

  return (
    <AddDriverWrapper>
      <Toast ref={toast} />
      <div className={"insured-wrapper "}>
        <div className="add_wrapper">
          <div className="form-wrapper">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-3">
                  <div className="field mb-4 d-flex align-items-start flex-column">
                    <label
                      htmlFor="idNumber"
                      className={classNames({
                        "p-error": isFormFieldValid("idNumber"),
                      })}
                    >
                      {i18n.t("ID_IQAMA")}
                      <span className="tawun_red"> *</span>
                    </label>
                    <InputText
                      id={"idNumber"}
                      name={"idNumber"}
                      value={formik.values.idNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      onKeyPress={globalUtils.numbersOnly}
                      maxLength={10}
                      disabled={disableForm}
                      className={classNames({
                        "p-invalid": isFormFieldValid("idNumber"),
                        lato: true,
                      })}
                    />

                    {getFormErrorMessage("idNumber")}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="field mb-4 d-flex align-items-start flex-column">
                    <label
                      htmlFor="yearOfBirth"
                      className={classNames({
                        "p-error": isFormFieldValid("yearOfBirth"),
                      })}
                    >
                      {i18n.t("YEAR_OF_BIRTH")}{" "}
                      <span className="tawun_red">*</span>
                    </label>
                    <Dropdown
                      id={"yearOfBirth"}
                      name={"yearOfBirth"}
                      value={formik.values.yearOfBirth}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      options={globalUtils.getGregYearOfBirthList()}
                      optionLabel="label"
                      // filter="true"
                      optionValue="value"
                      disabled={disableForm}
                      className={classNames({
                        "p-invalid": isFormFieldValid("yearOfBirth"),
                      })}
                    />
                    {getFormErrorMessage("yearOfBirth")}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="field mb-4 d-flex align-items-start flex-column">
                    <label
                      htmlFor="monthOfBirth"
                      className={classNames({
                        "p-error": isFormFieldValid("monthOfBirth"),
                      })}
                    >
                      {i18n.t("MONTH_OF_BIRTH")}{" "}
                      <span className="tawun_red">*</span>
                    </label>
                    <Dropdown
                      id={"monthOfBirth"}
                      name={"monthOfBirth"}
                      value={formik.values.monthOfBirth}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      options={globalUtils.months}
                      optionLabel="label"
                      // filter="true"
                      optionValue="value"
                      disabled={disableForm}
                      className={classNames({
                        "p-invalid": isFormFieldValid("monthOfBirth"),
                      })}
                    />
                    {getFormErrorMessage("monthOfBirth")}
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <Button
                    className="btn primary"
                    type="submit"
                    loading={loading}
                    disabled={disableForm}
                  >
                    {i18n.t("POLICY.RETRIEVE_INFORMATION")}
                  </Button>
                </div>
              </div>
            </form>
          </div>
          {driver && (
            <div className="drivers-list">
              <div className="row">
                <div className="col-12">
                  <label className="review">
                    {i18n.t("POLICY.REVIEW_ADD")}
                  </label>
                </div>
              </div>
              <div className="item" key={driver.idNumber}>
                <div className="details">
                  <div className="name-details">
                    <p className="header-title">{i18n.t("NAME")}</p>
                    <p className="license name">
                      {globalUtils.isArabic(i18n.language)
                        ? driver.araFirstName + " " + driver.araMidName
                        : driver.engFirstName + " " + driver.engLastName}
                    </p>
                  </div>
                </div>
                <div className="divider"> </div>
                <div className="usage">
                  <p className="header-title">{i18n.t("GENDER")}</p>
                  <div className="usage-list gender-list">
                    {isMale(driver.genderCode) ? (
                      <div
                        className={
                          "item"
                          // (isMale(driver.genderCode) ? " active" : "")
                        }
                        // onClick={() => onChangeGender("M")}
                      >
                        <div className="svg_wrapper">
                          <svg
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M33.04 15.875h-16.5a.75.75 0 0 1-.75-.75v-.75a9 9 0 0 1 18 0v.75a.75.75 0 0 1-.75.75zm-15.75-1.5h15a7.5 7.5 0 1 0-15 0z"
                              fill="#4C565C"
                            />
                            <path
                              d="M22.862 27.957h-.18a2.077 2.077 0 0 1-1.17-.375c-2.31-1.612-3.638-3.127-4.065-4.65-.08-.26-.13-.53-.15-.802v-7.005a.75.75 0 0 1 .75-.75h13.492a.75.75 0 0 1 .75.75v6.75c.008.095.008.19 0 .285-.018.27-.066.536-.142.795-.428 1.5-1.755 3-4.05 4.62-.36.263-.8.396-1.245.375h-.143c-.49-.007-.959-.2-1.312-.54a2.25 2.25 0 0 1-.608-.953 2.093 2.093 0 0 1-1.927 1.5zm-4.073-12.082v6.12c.01.174.042.345.098.51.33 1.178 1.5 2.46 3.465 3.84a.645.645 0 0 0 .33.113.556.556 0 0 1 .247 0 .75.75 0 0 0 .495-.825.75.75 0 0 1 .75-.75h1.23a.75.75 0 0 1 .75.75.93.93 0 0 0 .263.69.411.411 0 0 0 .307.134h.12a.54.54 0 0 0 .383-.105c1.972-1.38 3.135-2.662 3.465-3.817.055-.165.087-.336.097-.51.003-.05.003-.1 0-.15v-6h-12z"
                              fill="#4C565C"
                            />
                            <path
                              d="M18.04 21.125h-1.5a2.25 2.25 0 0 1-2.25-2.25v-2.25a2.25 2.25 0 0 1 2.25-2.25h1.5a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-.75.75zm-1.5-5.25a.75.75 0 0 0-.75.75v2.25a.75.75 0 0 0 .75.75h.75v-3.75h-.75zM33.04 21.125h-1.5a.75.75 0 0 1-.75-.75v-5.25a.75.75 0 0 1 .75-.75h1.5a2.25 2.25 0 0 1 2.25 2.25v2.25a2.25 2.25 0 0 1-2.25 2.25zm-.75-1.5h.75a.75.75 0 0 0 .75-.75v-2.25a.75.75 0 0 0-.75-.75h-.75v3.75zM32.29 12.875h-15a.75.75 0 0 1 0-1.5h15a.75.75 0 1 1 0 1.5zM39.79 38.803a.75.75 0 0 1-.75-.623 9.75 9.75 0 0 0-9.563-8.055h-.187a.75.75 0 0 1 0-1.5h.188a11.25 11.25 0 0 1 11.062 9.3.75.75 0 0 1-.608.863.352.352 0 0 1-.142.015zM9.789 38.803a.374.374 0 0 1-.128 0 .75.75 0 0 1-.622-.878 11.25 11.25 0 0 1 11.062-9.3h.188a.75.75 0 0 1 0 1.5H20.1a9.75 9.75 0 0 0-9.607 8.055.75.75 0 0 1-.705.623z"
                              fill="#4C565C"
                            />
                            <path
                              d="M24.788 31.625a7.738 7.738 0 0 1-1.5-.142h-.195l-.187-.046a7.89 7.89 0 0 1-3.075-1.425 8.19 8.19 0 0 1-3.293-6.637v-3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v1.62c.01.174.043.345.098.51.33 1.178 1.5 2.46 3.465 3.84a.645.645 0 0 0 .33.113.556.556 0 0 1 .247 0 .75.75 0 0 0 .495-.825.75.75 0 0 1 .75-.75h1.23a.75.75 0 0 1 .75.75.929.929 0 0 0 .263.69.411.411 0 0 0 .307.134h.12a.54.54 0 0 0 .383-.105c1.972-1.38 3.135-2.662 3.465-3.817.055-.165.088-.336.097-.51.003-.05.003-.1 0-.15v-1.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v3a8.19 8.19 0 0 1-3.3 6.6 8.047 8.047 0 0 1-3.112 1.44h-.383a7.66 7.66 0 0 1-1.455.21zm-1.35-1.642h.098a6.467 6.467 0 0 0 2.46 0h.24a6.606 6.606 0 0 0 2.602-1.208 6.705 6.705 0 0 0 2.633-4.417 12.48 12.48 0 0 1-3.39 3.217c-.36.263-.8.396-1.245.375h-.143c-.49-.007-.959-.2-1.312-.54a2.25 2.25 0 0 1-.593-.953 2.092 2.092 0 0 1-1.927 1.5h-.18a2.078 2.078 0 0 1-1.17-.375 12.697 12.697 0 0 1-3.405-3.224 6.75 6.75 0 0 0 2.632 4.417 6.51 6.51 0 0 0 2.55 1.17l.15.038z"
                              fill="#4C565C"
                            />
                            <path
                              d="M26.29 42.874a.75.75 0 0 1-.75-.75V30.717a.75.75 0 0 1 1.5 0v11.407a.75.75 0 0 1-.75.75zM23.29 42.874a.75.75 0 0 1-.75-.75V30.717a.75.75 0 0 1 1.5 0v11.407a.75.75 0 0 1-.75.75z"
                              fill="#4C565C"
                            />
                          </svg>
                        </div>
                        <span>{i18n.t("MALE")}</span>
                      </div>
                    ) : (
                      <div
                        className={
                          "item "
                          // (!isMale(driver.genderCode) ? " active" : "")
                        }
                        // onClick={() => onChangeGender("F")}
                      >
                        <div className="svg_wrapper">
                          <svg
                            viewBox="0 0 49 49"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M31.54 18.125h-1.5a3.75 3.75 0 0 0-3.75-3.75h-3a3.75 3.75 0 0 0-3.75 3.75h-1.5v-2.25a6.75 6.75 0 0 1 13.5 0v2.25zm-8.25-5.25h3a5.183 5.183 0 0 1 3.473 1.32 5.25 5.25 0 0 0-9.946-.008 5.25 5.25 0 0 1 3.473-1.312z"
                              fill="#4C565C"
                            />
                            <path
                              d="M24.79 27.125a6.75 6.75 0 0 1-6.75-6.75v-2.25a5.25 5.25 0 0 1 5.25-5.25h3a5.25 5.25 0 0 1 5.25 5.25v2.25a6.75 6.75 0 0 1-6.75 6.75zm-1.5-12.75a3.75 3.75 0 0 0-3.75 3.75v2.25a5.25 5.25 0 0 0 10.5 0v-2.25a3.75 3.75 0 0 0-3.75-3.75h-3z"
                              fill="#4C565C"
                            />
                            <path
                              d="M24.79 42.875c-8.497 0-16.5-3.803-16.5-6.75.001-.23.05-.458.143-.668l.855-3.42a7.5 7.5 0 0 1 6.502-5.625V14.375a9 9 0 0 1 9.165-9 9.188 9.188 0 0 1 8.835 9.27v11.767a7.499 7.499 0 0 1 6.502 5.625l.855 3.42c.093.21.142.438.143.668 0 2.947-8.002 6.75-16.5 6.75zm0-36a7.5 7.5 0 0 0-7.5 7.5v12.75a.75.75 0 0 1-.75.75 6 6 0 0 0-5.797 4.5l-.87 3.487a.807.807 0 0 1-.053.143.284.284 0 0 0-.03.12c0 1.267 6.225 5.25 15 5.25s15-3.983 15-5.25a.285.285 0 0 0 0-.098.815.815 0 0 1-.053-.142l-.9-3.51a6 6 0 0 0-5.797-4.5.75.75 0 0 1-.75-.75v-12.48a7.68 7.68 0 0 0-7.357-7.77h-.143z"
                              fill="#4C565C"
                            />
                            <path
                              d="M24.79 33.875c-4.965 0-9-2.858-9-6.375a.75.75 0 0 1 1.5 0c0 2.685 3.367 4.875 7.5 4.875a.75.75 0 1 1 0 1.5z"
                              fill="#4C565C"
                            />
                          </svg>
                        </div>
                        <span>{i18n.t("FEMALE")}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="divider"> </div>
                <div className="iqama">
                  <p className="header-title">{i18n.t("ID_IQAMA")}</p>
                  <p className="license">{driver.IDNO}</p>
                </div>
                <div className="divider"> </div>
                <div className="year-birth">
                  <p className="header-title">{i18n.t("YEAR_OF_BIRTH")}</p>
                  <p className="license">{driver.gregDob}</p>
                </div>

                {/* <div className="actions">
                  <p className="header-title"></p>
                  <div className="btns">
                    <button
                      type="button"
                      className="btn"
                      onClick={cancelAddDriver}
                    >
                      <img src={noIcon} alt="" />
                    </button>
                    <button type="button" className="btn " onClick={saveDriver}>
                      <img src={yesIcon} alt="" />
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </AddDriverWrapper>
  );
};

AddDriver.propTypes = propTypes.exact({
  driversList: propTypes.array.isRequired,
  driverInfo: propTypes.any.isRequired,
  editMode: propTypes.bool,
  updateDriverListHandler: propTypes.func,
  cancelUpdateDriverHandler: propTypes.func,
}).isRequired;
export default withTranslation()(AddDriver);
